import { useSuspenseQuery } from '@tanstack/react-query';
import type { GatheringSpot } from '@outdoria/types';
import { fetcher } from '../utils';
import { GATHERING_SPOTS_ALL } from '../queryKeys';

export type GatheringSpotWithTypeName = GatheringSpot & {
  gathering_type_name: string;
};

export const useGetGatheringSpotsAll = () => {
  const queryFn = async (): Promise<GatheringSpotWithTypeName[]> => {
    const res = await fetcher(`/v2/gathering_spots`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<
    GatheringSpotWithTypeName[],
    unknown,
    GatheringSpotWithTypeName[],
    string[]
  >({
    queryKey: GATHERING_SPOTS_ALL,
    queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
